import { useEffect, useMemo, useState } from "react";
import TagCreate from "V2.0/HomePages/Workspaces/Tags/WorkspaceTagCreate";
import TagsSection from "./TagsSection";
import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";
import {
  addTagToConversation,
  deleteTagFromConversation,
} from "V2.0/services/conversationService";

function ConversationTagsEdit(props) {
  const {
    open,
    onClose,
    workspaceId,
    workspaceTags,
    conversationTags,
    conversationId,
    onCreateNewTags,
    syncConversation,
  } = props;

  const [tagsAdded, setTagsAdded] = useState(conversationTags);

  useEffect(() => {
    setTagsAdded(conversationTags);
  }, [conversationTags]);

  const handleAdd = async (tag) => {
    message.loading("Adding Tag");
    try {
      const response = await addTagToConversation({
        workspaceId,
        conversationId,
        payload: { tag },
      });
      if (response.status === 200) {
        message.destroy();
        message.success("Tag added");
        syncConversation(response.data);
      }
    } catch (e) {
      message.destroy();
      showErrorToast(e, "Failed to add tag");
    }
  };

  const handleRemove = async (tag) => {
    message.loading("Removing Tag");
    try {
      const response = await deleteTagFromConversation({
        workspaceId,
        conversationId,
        payload: { tag },
      });

      if (response.status === 200) {
        message.destroy();
        message.success("Tag removed");
        syncConversation(response.data);
      }
    } catch (e) {
      message.destroy();
      showErrorToast(e, "Failed to remove tag");
    }
  };

  const tags = useMemo(() => {
    return workspaceTags.map((tag) => {
      return { name: tag, isChecked: tagsAdded.includes(tag) };
    });
  }, [workspaceTags, tagsAdded]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Tags</DialogTitle>
      <DialogBody>
        <TagCreate
          workspaceId={workspaceId}
          workspaceTags={workspaceTags}
          onCreateNewTags={onCreateNewTags}
        />
        {Boolean(tags.length) ? (
          <TagsSection
            tags={tags}
            onCheckTag={handleAdd}
            onUncheckTag={handleRemove}
          />
        ) : (
          <div className="w-full h-40 border rounded-lg flex items-center justify-center">
            <p className="text-sm text-gray-600">Create tags to assign</p>
          </div>
        )}
      </DialogBody>
      <DialogActions>
        <Button outline onClick={onClose}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConversationTagsEdit;
